/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API - V2 Redesigned
 * Redesigned API endpoints (v2) for better performance with smaller, functional DTOs. Each endpoint provides only the data needed for specific UI components/tabs.  V2 endpoints are designed to replace heavy monolithic v1 endpoints: - Reduced response sizes by 80-95% - Component-specific data loading - Pagination and filtering support - Optimized for mobile and slow connections 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamRegistrationTemplateFieldRule
 */
export interface TeamRegistrationTemplateFieldRule {
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationTemplateFieldRule
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationTemplateFieldRule
     */
    fieldKey?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationTemplateFieldRule
     */
    fieldLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationTemplateFieldRule
     */
    fieldType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeamRegistrationTemplateFieldRule
     */
    isCustomField?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeamRegistrationTemplateFieldRule
     */
    isVisible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeamRegistrationTemplateFieldRule
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeamRegistrationTemplateFieldRule
     */
    isLocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationTemplateFieldRule
     */
    defaultValue?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamRegistrationTemplateFieldRule
     */
    options?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TeamRegistrationTemplateFieldRule
     */
    sortOrder?: number;
}

/**
 * Check if a given object implements the TeamRegistrationTemplateFieldRule interface.
 */
export function instanceOfTeamRegistrationTemplateFieldRule(value: object): value is TeamRegistrationTemplateFieldRule {
    return true;
}

export function TeamRegistrationTemplateFieldRuleFromJSON(json: any): TeamRegistrationTemplateFieldRule {
    return TeamRegistrationTemplateFieldRuleFromJSONTyped(json, false);
}

export function TeamRegistrationTemplateFieldRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamRegistrationTemplateFieldRule {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fieldKey': json['field_key'] == null ? undefined : json['field_key'],
        'fieldLabel': json['field_label'] == null ? undefined : json['field_label'],
        'fieldType': json['field_type'] == null ? undefined : json['field_type'],
        'isCustomField': json['is_custom_field'] == null ? undefined : json['is_custom_field'],
        'isVisible': json['is_visible'] == null ? undefined : json['is_visible'],
        'isRequired': json['is_required'] == null ? undefined : json['is_required'],
        'isLocked': json['is_locked'] == null ? undefined : json['is_locked'],
        'defaultValue': json['default_value'] == null ? undefined : json['default_value'],
        'options': json['options'] == null ? undefined : json['options'],
        'sortOrder': json['sort_order'] == null ? undefined : json['sort_order'],
    };
}

export function TeamRegistrationTemplateFieldRuleToJSON(json: any): TeamRegistrationTemplateFieldRule {
    return TeamRegistrationTemplateFieldRuleToJSONTyped(json, false);
}

export function TeamRegistrationTemplateFieldRuleToJSONTyped(value?: TeamRegistrationTemplateFieldRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'field_key': value['fieldKey'],
        'field_label': value['fieldLabel'],
        'field_type': value['fieldType'],
        'is_custom_field': value['isCustomField'],
        'is_visible': value['isVisible'],
        'is_required': value['isRequired'],
        'is_locked': value['isLocked'],
        'default_value': value['defaultValue'],
        'options': value['options'],
        'sort_order': value['sortOrder'],
    };
}

